import React from 'react';
import { useSelector } from 'react-redux';
import Menu from '../Menu';
import config from '../../config.json';
import './AllocatedUnit.css';
import '../organization/Person.css';
import { selectColorCodeBySystemName, selectAllCurrentItemsByPersonId } from '../../Selectors';

const AllocatedUnit = () => {
    const allocatedUnits = useSelector((state) => state.allocatedUnitState.allocatedUnits); // Access allocated units from state
    const personState = useSelector((state) => state.personState);
    const checkColor = useSelector((state) => selectColorCodeBySystemName(state, 'checked'));
    const uncheckColor = useSelector((state) => selectColorCodeBySystemName(state, 'unchecked'));
    const itemsByPersonId = useSelector((state) => selectAllCurrentItemsByPersonId(state));

    // const style = {border: 'none'}; //{ borderColor: 'black', borderRadius: '50%', borderStyle: 'solid'};

    const createPersonView = (unitId, person) => {
        const item = itemsByPersonId[person.personId];
        var status = personState.persons[person.personId]?.status;

        let className="person clearfix"
        let style = {borderRadius: '50%', borderStyle: 'solid'};
        if(status === 'checked'){
            className += ' circle checked';
            style = { ...style, borderColor:`${checkColor && checkColor.hexColor}`};
        }
        if(status === 'unchecked'){
            className += ' circle unchecked';
            style = { ...style, borderColor:`${uncheckColor && uncheckColor.hexColor}`};
        }
        if(item){
            className += ' circle';
            style = { ...style, borderColor:`${item.colorCode.hexColor}`};
        }

        return (
            <div key={`${unitId}-${person.name}`} className="person clearfix circle" style={{ marginBottom: '1.1vw' }}>
                <div className={ className } style={{ marginBottom: '0' }}>
                    <img className="profile-img" src={config.server + person.imagePath} alt="" style={style ? style : {}}/>
                </div>
                <div className="flytext">{person.name}</div>
                <div className="flytext-title">{person.title}</div>
                <div className="flytext-phone">{person.contactPhoneNumber}</div>
            </div>
        );
    };

    return (
        <div className="App">
            <Menu />
            <div className="AllocatedUnit">
                <div className="padding-content">
                    <div className="units-container">
                        <h2>Biler</h2>
                        <div className="units">
                            {allocatedUnits.map((allocatedUnit) => (
                                <div key={`allocated-unit-${allocatedUnit.id}`} className="unit">
                                    <div className="allocated-unit-info">
                                        <p className="allocated-unit-name-small">{allocatedUnit.name}</p>
                                        <p className="allocated-unit-name-small">
                                            {allocatedUnit.internalId} - {allocatedUnit.registrationNo}
                                        </p>
                                        {allocatedUnit.allocatedUnitOwners &&
                                            allocatedUnit.allocatedUnitOwners.map((owner) =>
                                                createPersonView(allocatedUnit.id, owner)
                                            )}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="clearfix" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllocatedUnit;